import React from 'react';
import { useRevealAnimation } from '@/hooks/useRevealAnimation';

type Heading1Props = {
  children?: React.ReactNode;
  text?: string;
  id?: string;
  description?: string;
};

export const Heading1: React.FC<Heading1Props> = ({
  children,
  text,
  id,
  description,
}) => {
  const { ref, isVisible } = useRevealAnimation();

  return (
    <div className="my-24">
      <h1
        ref={ref}
        id={id}
        className={`text-4xl mb-3 dark:text-white scroll-mt-24 transform transition-all duration-700 ${
          isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
        }`}
      >
        {text ?? children}
      </h1>

      {description && (
        <p
          className={`text-xl text-zinc-700 dark:text-zinc-300 mt-4 mb-8 transform transition-all duration-700 delay-100 ${
            isVisible ? 'translate-y-0 opacity-100' : 'translate-y-6 opacity-0'
          }`}
        >
          {description}
        </p>
      )}

      <div
        className={`w-full h-px bg-zinc-200 dark:bg-zinc-800 transform transition-all duration-700 delay-200 ${
          isVisible ? 'opacity-100' : 'opacity-0'
        }`}
      />
    </div>
  );
};
